import { DATE_FORMAT } from '@/helpers/dates';
import { Box, DateInput } from '@palmetto/palmetto-components';
import { useFormikContext } from 'formik';
import { DateTime } from 'luxon';
import { useCallback } from 'react';

import { documentTitles, DocumentTypes } from 'types';

import FormSection from '../Forms/FormSection';
import { DocumentList } from '../MilestonePackagePartials/Documents/DocumentList';

export const ExecutedEscrowAgreement = ({ isPackageEditable }: { isPackageEditable: boolean }) => {
  const { values, setFieldValue, validateField, isSubmitting, touched, errors } = useFormikContext<any>();
  const handleDateChange = useCallback(
    (date: Date | [Date, Date] | null, field: string) => {
      if (!date || !(date instanceof Date)) return;
      const formattedDate = DateTime.fromJSDate(date).toLocal().toFormat(DATE_FORMAT);
      setFieldValue(field, formattedDate).then(() => {
        validateField(field);
      });
    },
    [setFieldValue, validateField],
  );

  return (
    <FormSection
      title="Executed Escrow Agreement"
      description="Upload the executed escrow agreement document and provide the date it was executed."
    >
      <Box margin="0 0 lg 0" gap="md">
        <DocumentList
          documentTypeFilter={[DocumentTypes.executedEscrowAgreement]}
          title="Executed Escrow Agreement"
          showTypeLabelOnItems={false}
          baseCategory={documentTitles.executedEscrowAgreement}
          allowArchive={false}
          isPackageEditable={isPackageEditable}
        />{' '}
        <DateInput
          id="executedEscrowAgreementDocumentDate"
          name="executedEscrowAgreementDocumentDate"
          placeholder="MM-DD-YYYY"
          label="Executed Escrow Agreement Date"
          helpText="If you do not have the exact date, an estimated date can be provided"
          value={values.executedEscrowAgreementDocumentDate}
          error={
            touched.executedEscrowAgreementDocumentDate && errors.executedEscrowAgreementDocumentDate
              ? errors.executedEscrowAgreementDocumentDate
              : undefined
          }
          isDisabled={!isPackageEditable || isSubmitting}
          datePickerProps={{
            onChange: (date) => handleDateChange(date, 'executedEscrowAgreementDocumentDate'),
            selected: values.executedEscrowAgreementDocumentDate
              ? DateTime.fromFormat(values.executedEscrowAgreementDocumentDate, DATE_FORMAT).toJSDate()
              : undefined,
          }}
          textInputProps={{
            width: { base: '3xl', tablet: '4xl' },
            inputProps: {
              readOnly: true,
            },
          }}
        />
      </Box>
    </FormSection>
  );
};
